@if (startUpSvc.loading) {
  <dfup-loading-screen></dfup-loading-screen>
} @else {
  <router-outlet></router-outlet>
}
